<template>
    <article class="product-config-card">
        <div class="product-config-card__main">
            <span class="product-config-card__image" :style="imageStyle" role="img" :aria-label="product.name"></span>
            <span class="product-config-card__name">{{ product.name }}</span>
            <ToggleSwitch :value="product.status" :label="product.name" @input="$emit('toggle')" />
        </div>
        <div v-if="false" class="product-config-card__field">
            <select class="product-config-card__container" :value="activeValue" :aria-label="product.name" :disabled="options.length <= 1" @change="onContainerChange">
                <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
            </select>
            <i class="i-andy-chevron-input-down i-andy-m product-config-card__chevron" aria-hidden="true"></i>
        </div>
    </article>
</template>

<script>
import ToggleSwitch from '@/components/domain/ui/ToggleSwitch.vue'

const OPTION_SOURCES = [
    { list: 'containers', active: 'active_container', field: 'container' },
    { list: 'packages', active: 'active_package', field: 'package' },
    { list: 'drops', active: 'active_drop', field: 'drop' },
    { list: 'units', active: 'active_unit', field: 'unit' }
]

export default {
    name: 'ProductConfigCard',
    components: { ToggleSwitch },
    props: {
        product: { type: Object, required: true }
    },
    computed: {
        optionSource() {
            return OPTION_SOURCES.find((source) => {
                const list = this.product[source.list]
                return list && typeof list === 'object' && Object.keys(list).length > 0
            }) || null
        },
        options() {
            if (!this.optionSource) {
                return []
            }
            return Object.entries(this.product[this.optionSource.list]).map(([key, item]) => ({
                id: item && item.id != null ? item.id : key,
                name: item && item.name ? item.name : ''
            }))
        },
        activeValue() {
            if (!this.optionSource) {
                return null
            }
            return this.product[this.optionSource.active]
        },
        imageStyle() {
            if (!this.product.image) {
                return {}
            }
            return { backgroundImage: `url(${this.product.image})` }
        }
    },
    methods: {
        onContainerChange(event) {
            if (!this.optionSource) {
                return
            }
            this.$emit('container', { field: this.optionSource.field, value: event.target.value })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.product-config-card {
    @include display-flex();
    @include flex-direction(column);
    gap: 8px;
    padding: 8px;
    border: 1px solid $neutro-dark;
    border-radius: $phu-radius-s;
    background-color: $phu-surface;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.02), 0 2px 2px rgba(0, 0, 0, 0.08);

    &__main {
        @include display-flex();
        @include align-items(center);
        gap: 8px;
    }

    &__image {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }

    &__name {
        flex: 1;
        min-width: 0;
        font-family: $text-bold;
        font-size: 1.5rem;
        line-height: 29px;
        text-transform: uppercase;
        @include text-ellipsis();
        color: $phu-text;
    }

    &__field {
        position: relative;
        width: 100%;
    }

    &__container {
        width: 100%;
        height: 40px;
        padding: 8px 48px 8px 8px;
        border: 1px solid $neutro-dark;
        border-radius: $phu-radius-s;
        background-color: $phu-surface;
        font-family: $text;
        line-height: 18px;
        color: $neutro-s50;
        -webkit-appearance: none;
        appearance: none;
        font-size: 1rem;

        &:disabled {
            cursor: not-allowed;
        }
    }

    &__chevron {
        position: absolute;
        top: 8px;
        right: 8px;
        color: $neutro-s50;
        pointer-events: none;
    }
}
</style>
